var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("SeaExport.PreviewOfBookingFileParsing"),
        "custom-class": "intelligent-booking-result-dialog",
        visible: _vm.innerVisible,
        fullscreen: "",
        modal: false,
        "append-to-body": true,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { width: "100%", height: "100%" },
          attrs: {
            "left-style": { "min-width": "550px", width: "50%" },
            "right-style": { "min-width": "550px", width: "50%" }
          }
        },
        [
          _c("template", { slot: "left" }, [
            _c(
              "div",
              {
                staticStyle: { width: "100%", height: "100%", overflow: "auto" }
              },
              [
                _vm.visible
                  ? _c("image-preview", {
                      attrs: {
                        "image-info": _vm.resultJson,
                        "cur-focus": _vm.curFocus
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("template", { slot: "right" }, [
            _c(
              "div",
              {
                staticStyle: { width: "100%", height: "100%", overflow: "auto" }
              },
              [
                _vm.visible
                  ? _c("result-form", {
                      ref: "resultForm",
                      attrs: { details: _vm.details },
                      on: {
                        fieldFocus: function(val) {
                          return (_vm.curFocus = val)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm.details.status === 3
        ? _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { no: "1" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("Message.Close")))]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "2", type: "success" },
                  on: { click: _vm.handleSave }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "3", type: "primary" },
                  on: { click: _vm.handleCreateOrder }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.GenerateOrder")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "4" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }